<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd"
					v-hasPermi="['system:dept:add']">新增
				</el-button>
			</el-col>
		</el-row>

		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<!-- <el-form-item class="my-form-item">
							<el-select size="mini" clearable v-model="quertInfo.objMap.status" placeholder="选择状态">
								<el-option label="启用" value="0"></el-option>
								<el-option label="禁用" value="1"></el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" icon="el-icon-search" @click="onSearch"
								v-hasPermi="['system:dept:query']">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" row-key="id" size="mini"
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="deptName" label="部门名称" width="160px"></el-table-column>
					<el-table-column prop="orderNum" label="排序" :show-overflow-tooltip="true" width="60">
					</el-table-column>
					<el-table-column prop="leader" label="负责人" :show-overflow-tooltip="true" width="90">
					</el-table-column>
					<el-table-column prop="phone" label="联系电话" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="purchaseOrg" label="是否采购组织" width="95" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="stockOrg" label="是否库存组织"  width="95" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="purchaseDept" label="是否采购部门"   width="95" :show-overflow-tooltip="true"></el-table-column>
					<!-- <el-table-column prop="status" label="部门状态" width="80" :formatter="formatStatus"></el-table-column> -->
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" size="mini" v-if="scope.row.id!=1" @click="handleEdit(scope.row)"
								v-hasPermi="['system:dept:edit']">修改
							</el-button>
							<el-button type="text" icon="el-icon-delete" size="mini" v-if="scope.row.id!=1" @click="handleDel(scope.row)"
								v-hasPermi="['system:dept:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</el-row>
		<el-dialog :visible.sync="openDialog" width="1000px" :title="title">
			<el-form label-width="120px" ref="form" :model="form" :rules="rules">
				<el-row>
					<el-col :span="24" v-if="form.parentId != 0">
						<el-form-item label="上级部门" prop="parentId">
							<treeselect v-model="form.parentId" :show-count="true" :options="optionDepts"
								:normalizer="normalizer" placeholder="选择上级部门" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="部门名称" prop="deptName">
							<el-input v-model="form.deptName" placeholder="请输入部门名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="显示顺序" prop="orderNum">
							<el-input-number v-model="form.orderNum" controls-position="right" style="width:100%" :min="1" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人" prop="leader">
							<el-input v-model="form.leader" placeholder="请输入负责人" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系电话" prop="phone">
							<el-input v-model="form.phone" placeholder="请输入联系电话" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="form.email" placeholder="请输入邮箱" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否采购组织" prop="purchaseOrg">
							<el-radio-group v-model="form.purchaseOrg">
								<el-radio label="是">是</el-radio>
								<el-radio label="否">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否库存组织" prop="stockOrg">
							<el-radio-group v-model="form.stockOrg">
								<el-radio label="是">是</el-radio>
								<el-radio label="否">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否采购部门" prop="purchaseDept">
							<el-radio-group v-model="form.purchaseDept">
								<el-radio label="是">是</el-radio>
								<el-radio label="否">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
						<el-form-item label="状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio :label="0">启用</el-radio>
								<el-radio :label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col> -->
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="openDialog = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		deptList,
		addDept,
		editDept,
		delDept
	} from '@/api/system/dept.js'
	import Treeselect from '@riophae/vue-treeselect'
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'

	export default {
		name: "Dept",
		computed: {},
		components: {
			Treeselect
		},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				openDialog: false,
				optionDepts: [],
				quertInfo: {
					objMap: {
						search: ''
					},
				},
				rules: {
					parentId: [{
						required: true,
						message: '请选择部门',
						trigger: 'blur'
					}],
					deptName: [{
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList()
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await deptList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//搜索按钮
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					parentId: undefined,
					deptName: undefined,
					orderNum: undefined,
					leader: undefined,
					phone: undefined,
					email: undefined,
					status: 0,
					purchaseOrg:'否',
					stockOrg:'否',
					purchaseDept:'否',
				};
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if (_this.form.id != undefined) {
							editDept(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							addDept(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			/**
			 * 转换菜单数据结构
			 * vue-treeselect中，即使您为children属性分配一个空数组，依然会显示有分支，这时就可以使用normalizer去掉children属性：
			 */
			normalizer(node) {
				if (node.children && !node.children.length) {
					delete node.children;
				}
				return {
					id: node.id,
					//将name转换成必填的label键
					label: node.deptName,
					children: node.children
				};
			},
			/** 查询菜单下拉树结构 */
			getTreeselect() {
				let _this = this;
				_this.optionDepts = [];
				const dept = _this.$handleTree(_this.tableData, "id");
				_this.optionDepts = dept;

			},
			handleAdd: function() {
				this.reset();
				this.getTreeselect();
				this.title = "新增部门表";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.getTreeselect();
				this.title = "修改部门表";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				delete this.form.children;
				this.openDialog = true;
			},
			handleDel: function(row) {
				let _this = this;
				if (row.parentId == 0) {
					_this.$fail("不能删除最上级部门");
					return false;
				}
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delDept(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.open = false;
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: row.id
					} //参数对象 主要回调函数用
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			}
		}
	};
</script>
<style scoped="scoped">
</style>
